import { API_CONFIG } from '@/shared/configs/apiConfig.js'

export default {
  url(payload) {
    const service = payload?.service || API_CONFIG.SERVICES.RAPIDOO_DATA_MOCK
    const group = payload?.group || API_CONFIG.GROUP
    const userId = payload?.userId || 'rapidoo-data-mock'
    return `${API_CONFIG.BASE_URLS.PAYMENT}/store/app/data?service=${service}&userId=${userId}&group=${group}`
  },

  parse(raw = {}, payload = {}) {
    try {
      const { storeId } = payload

      if (!storeId) {
        return {
          statusCode: 400,
          message: 'storeId is required',
          data: null,
        }
      }

      // Récupérer les restaurants pour avoir l'userId
      let restaurants = []
      if (raw?.data?.appInfo?.restaurants?.data) {
        const restData = raw.data.appInfo.restaurants.data
        restaurants = Array.isArray(restData) ? restData : [restData]
      }

      const restaurant = restaurants.find(r => r.id === storeId || r.userId === storeId)

      // 1. Solde disponible: utiliser les soldes globaux depuis appInfo.balances
      let availableBalance = 0
      if (raw?.data?.appInfo?.balances?.data?.restaurantBalance) {
        availableBalance = Number(raw.data.appInfo.balances.data.restaurantBalance || 0)
      }

      // 2. Solde en attente: calculer depuis les commandes de ce restaurant
      // Utiliser window.__RAPIDOO_GLOBAL_DATA__ pour avoir toutes les commandes (comme restaurants.js)
      const globalData = typeof window !== 'undefined' ? window.__RAPIDOO_GLOBAL_DATA__ : null
      let orders = globalData?.orders || []

      const restaurantOrders = orders.filter(o => o.storeId === storeId)

      let pendingBalance = 0
      let pendingOrderCount = 0
      restaurantOrders.forEach(order => {
        if (!order.pickedAt && !order.pickedUpAt) {
          pendingBalance += Number(order.totalPrice || order.amount || 0)
          pendingOrderCount++
        }
      })

      const totalBalance = availableBalance + pendingBalance

      return {
        statusCode: 200,
        message: 'Ok',
        data: {
          availableBalance,
          pendingBalance,
          totalBalance,
          pendingOrderCount,
          storeId,
          storeName: restaurant?.storeName || '',
        },
      }
    } catch (error) {
      console.error('RestaurantBalances fetch error:', error)
      return {
        statusCode: 500,
        message: error.message || 'Error fetching restaurant balances',
        data: {
          availableBalance: 0,
          pendingBalance: 0,
          totalBalance: 0,
          pendingOrderCount: 0,
        },
      }
    }
  },
}
